module.exports = __webpack_public_path__ + "static/media/agua.8a676661.png";